var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2625 2.77231H1.75C1.28587 2.77231 0.840752 2.95669 0.512563 3.28488C0.184374 3.61307 0 4.05819 0 4.52231V13.9723C0 14.4364 0.184374 14.8816 0.512563 15.2098C0.840752 15.5379 1.28587 15.7223 1.75 15.7223H11.375C12.3375 15.7223 13.125 14.8473 13.125 13.8848V6.97231L9.625 10.6473C9.3625 10.9098 9.0125 11.1723 8.575 11.2598L6.2125 11.7848C4.725 12.0473 3.325 10.6473 3.5875 9.07231L4.1125 6.53481C4.2 6.09731 4.4625 5.65981 4.725 5.39731L7.35 2.68481L7.2625 2.77231Z",
    fill: "#CACACA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7 1.10988C14.5354 0.693092 14.2243 0.350794 13.825 0.147383C13.5058 0.00736156 13.152 -0.0341294 12.809 0.0282287C12.466 0.0905868 12.1495 0.253952 11.9 0.497383L11.375 1.02238L13.9125 3.64738L14.35 3.12238C14.5198 2.9491 14.6537 2.74391 14.7438 2.51864C14.8339 2.29337 14.8785 2.05248 14.875 1.80988C14.875 1.63488 14.875 1.37238 14.7 1.10988ZM12.6 4.95988L10.15 2.33488L5.95 6.70988L5.8625 6.97238L5.25 9.59738C5.25 9.85988 5.5125 10.2099 5.775 10.1224L8.1375 9.59738L8.4 9.50988L12.5125 5.13488L12.6 4.95988Z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9a743a09d5270d1a49ac9dcaf496d9e4.svg";
export { ForwardRef as ReactComponent };